document.addEventListener('DOMContentLoaded',  function() {
    var swiper_setup = new window.swiper(".text-video-slider-setup-use", {
        lazy: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          clickable: true,
        },
        navigation: {
            nextEl: '.setup-button-next',
            prevEl: '.setup-button-prev',
        },
    });
    
    var swiper_benefits = new window.swiper(".text-video-slider-benefits", {
        lazy: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.benefits-button-next',
            prevEl: '.benefits-button-prev',
        },
    });
    
    var compare_products = new window.swiper(".swiper.compare-products", {
        lazy: true,
        slidesPerView: "auto",
        navigation: {
            nextEl: ".compare-products-container .swiper-button-next",
            prevEl: ".compare-products-container .swiper-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            hide: false,
          },
    });

    const compare_products_wrapper = document.querySelector('.compare-products-wrapper');
    const view_mores = document.querySelectorAll('[view-more]');
    
    if (compare_products_wrapper && view_mores) {
        const view_more_text = document.querySelector('.compare-products-container').getAttribute('data-more');
        const view_less_text = document.querySelector('.compare-products-container').getAttribute('data-less');
        view_mores.forEach(view_more => {
            view_more.addEventListener('click', function(e) {
                e.preventDefault();
                compare_products_wrapper.classList.toggle('show-more');
                if (compare_products_wrapper.classList.contains('show-more')) {
                    view_more.innerHTML = view_less_text;
                }
                else {
                    view_more.innerHTML = view_more_text;
                }
            });
        })
    }

    // show prices differences
    const other_prices = document.querySelectorAll('[other-product]');
    const currency_container = document.querySelector('.compare-products-container');
    if(currency_container){ 
        const currency = currency_container.getAttribute('data-money-format');
        const this_product = document.querySelector('[this-product]');
        if (other_prices.length > 0 && this_product !== null) {
            const this_product_price = this_product.getAttribute('data-price');
            const more_than_text = document.querySelector('.compare-products-container').getAttribute('data-more-than');
            other_prices.forEach(price => {
                let other_price = price.getAttribute('data-price');
                let price_difference = other_price - this_product_price;
                if (price_difference > 0) {
                    let price_difference_text = Shopify.formatMoney(price_difference,currency);
                    price.innerHTML = more_than_text + ' ' + price_difference_text;
                } else {
                    price.style.display = 'none';
                }
            }
        )}
    }
    
   

    
    var swiper_complementary = new window.swiper(".complementary-products-slider", {
        slidesPerView: 1.4,
        spaceBetween: 30,
        lazy: true,
        breakpoints: {
            768: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 4
            }
        },
        navigation: {
            nextEl: '.complementary-products-slider-container .swiper-button-next',
            prevEl: '.complementary-products-slider-container .swiper-button-prev',
        },
        on: {
            init: function () {
                console.log('Complementary swiper init')
            },
        }
    });
    
    const video_triggers = document.querySelectorAll('.play-video-trigger');
    if (video_triggers) {
        window.addEventListener('click', function (e) {
            if (e.target.classList.contains('play-video-trigger')) {
                let video = e.target.closest('.video-wrapper').querySelector('video');
                let overlay = e.target.closest('.video-wrapper').querySelector('.video-overlay');
                // Play Video
                video.play();
                overlay.style.display = 'none';
                
                // Hide Play Button
                e.target.classList.add('playing');
            } else if (e.target.tagName.toLowerCase() == 'video') {
                let video = e.target.closest('.video-wrapper').querySelector('video');
                let trigger = e.target.closest('.video-wrapper').querySelector('.play-video-trigger');
                let overlay = e.target.closest('.video-wrapper').querySelector('.video-overlay');
                // Pause Video
                video.pause();
                overlay.style.display = 'block';
                // Show Play Button
                trigger.classList.remove('playing');
            }
        });
    }
    
    // In View Autoplay
    const intersection_videos = document.querySelectorAll('.video-wrapper.autoplay-in-view');
    
    if (intersection_videos) {
        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.1,
        };
        
        let callback = function (entries) {
            entries.forEach(function (entry) {
                let video = entry.target.querySelector('video');
                const video_trigger = video.closest('.video-wrapper').querySelector('.play-video-trigger');
                const overlay = entry.target.querySelector('.video-overlay');
                if (!entry.isIntersecting) {
                    // console.log('Pausing video',video);
                    video.pause();
                    overlay.style.display = 'block';
                    if ( video_trigger ) {
                        video_trigger.classList.remove('playing')
                    }
                } else if (entry.isIntersecting) {
                    // console.log('Playing video',video);
                    video.play();
                    setTimeout(function () {
                        overlay.querySelector('img').style.display = 'none';
                      }, 100);
                    if (!video.paused) {
                        overlay.style.display = 'none';
                    }
                    
                    if ( video_trigger ) {
                        video_trigger.classList.add('playing')
                    }
                }
            });
        };
      
        let observer = new IntersectionObserver(callback, options);
        
        intersection_videos.forEach((videoWrapper) => {
            observer.observe(videoWrapper);
        });
    }
    const header_height = document.querySelector('.mega-menu-outer-shopify-wrapper').offsetHeight;
    document.querySelector('.information-links-bar').style.top = header_height + 'px';

    var swiper_tabs = new window.swiper(".info-tabs", {
        slidesPerView: "auto",
        centered: true,
	});

	const information_containers = document.querySelectorAll('.information-content');
    
    let options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
    };
    
    // intersection observer to detect when the information container is in view and add class to tab
    const callback = (entries) => {
        entries.forEach(entry => {
            let id = entry.target.getAttribute('id');
            let index = Array.from(information_containers).indexOf(entry.target);
            if (entry.isIntersecting) {
                document.querySelector(`.information-links-bar [data-title="${id}"]`).classList.add('in-view');
                swiper_tabs.slideTo(index, 500, false);
            } else {
                document.querySelector(`.information-links-bar [data-title="${id}"]`).classList.remove('in-view');
            }
        })
    } 

    const observer = new IntersectionObserver(callback, options);

    // add observer to each information container
    information_containers.forEach(container => {
        observer.observe(container);
    });


});